// extracted by mini-css-extract-plugin
module.exports = {"agenda":"agenda_agenda__zVz3f","table":"agenda_table__lxFQL","item":"agenda_item__zhqK9","timeSlot":"agenda_timeSlot__bdHmi","description":"agenda_description__XLMNf"};